import { render, staticRenderFns } from "./VersionChangeModal.vue?vue&type=template&id=a8167082&scoped=true&"
import script from "./VersionChangeModal.vue?vue&type=script&lang=js&"
export * from "./VersionChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./VersionChangeModal.vue?vue&type=style&index=0&id=a8167082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8167082",
  null
  
)

export default component.exports